import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Offering } from '@/domain/offerings/offering'
import { Users } from 'lucide-react'
import { AgePricingEditor } from './AgePricingEditor'

interface OfferingAgePricingCardProps {
  offering: Offering
  canManage: boolean
}

export const OfferingAgePricingCard = ({ offering, canManage }: OfferingAgePricingCardProps) => {
  const activePrice = offering.prices?.find(p => !p.effectiveUntil || new Date(p.effectiveUntil) > new Date());
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4 border-b">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <Users className="h-5 w-5 text-muted-foreground" />
            <CardTitle>Precios por Edad</CardTitle>
          </div>
          <CardDescription>Detalle de los precios actuales por edad para este servicio</CardDescription>
        </div>
      </CardHeader>
      <CardContent className="pt-6">
        <AgePricingEditor
          offeringId={offering.id}
          activePriceId={activePrice?.id}
          canManage={canManage}
        />
      </CardContent>
    </Card>
  )
}
